/**
 * Get cookie by name
 * 
 * @param name Cookie name
 */
export function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

/**
 * Delete cookie by name by setting its expiration date to a past date
 * 
 * @param name Cookie name
 */
export function deleteCookie(name: string) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}